'use strict';

var _ref, _groupId, _groupId2, _groupId3, _groupId4, _groupId5, _groupId6, _groupId7, _groupId8, _ref2, _ref3, _ref4, _ref6, _ref7;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _require = require('../enums'),
    plData = _require.plData,
    resellerType = _require.resellerType;

var type = require('./type');
var availability = require('./availability');
var tag = require('./tag');

var defaultStartDate = '2001-01-01';

module.exports = [{
  id: 1,
  tag: tag.STANDARD,
  type: type.AUTOMATIC,
  automaticTypeId: 2,
  shouldConfirmOptOut: true,
  key: 'automatic-opt-in-special',
  startDate: '2015-04-02'
}, {
  id: 3,
  tag: tag.STANDARD,
  type: type.PL_DATA,
  plDataCategoryId: plData.ROUND_UP_FOR_CHARITY_PROMO,
  key: 'round-up-for-charity',
  startDate: '2015-04-02',
  availability: availability.NOT_INDIA
}, {
  id: 5,
  tag: tag.STANDARD,
  type: type.PL_DATA,
  plDataCategoryId: plData.INDIA_CPANEL_PROMO,
  key: 'india-cpanel',
  startDate: '2012-10-11',
  endDate: '2024-01-01',
  availability: availability.INDIA_ONLY,
  requiresMultiCurrencyPricing: true,
  ratesAppSettingKeys: {
    'web-hosting': 'RCC_INDIA_WEB_HOSTING_RATES'
  }
}, {
  id: 6,
  tag: tag.STANDARD,
  type: type.PL_DATA,
  plDataCategoryId: plData.INDIA_PRODUCT_SALE_PROMO,
  key: 'india-product-sale',
  startDate: '2016-10-11',
  endDate: '2024-01-01',
  availability: availability.INDIA_ONLY,
  requiresMultiCurrencyPricing: true,
  requiresProductOfferings: ['web-hosting', 'quick-shopping-cart-reg'],
  ratesAppSettingKeys: {
    'ssl-certificates': 'RCC_INDIA_SSL_RATES',
    'wildcard-ssl-certificates': 'RCC_INDIA_WILDCARD_SSL_RATES',
    'virtual-hosting': 'RCC_INDIA_VPS_RATES',
    'dedicated-hosting': 'RCC_INDIA_VDED_RATES',
    'shared-hosting': 'RCC_INDIA_SHARED_HOSTING_RATES',
    'mwp': 'RCC_INDIA_MWP_RATES'
  }
}, {
  id: 7,
  tag: tag.STANDARD,
  type: type.ADVANCED_MARKETING,
  marketingTypeId: 1,
  key: 'advanced-marketing-email-campaigns',
  startDate: defaultStartDate
}, {
  id: 8,
  tag: tag.DOMAINS,
  type: type.PL_DATA,
  plDataCategoryId: plData.CO_REGISTRATION_SALE_PROMO,
  key: 'co-registration-sale',
  startDate: defaultStartDate,
  endDate: '2019-02-28',
  availability: availability.NOT_INDIA,
  pricing: [{
    product: 'co',
    salePrice: {
      USD: 999,
      GBP: 799,
      EUR: 899,
      CAD: 1399,
      AUD: 1399,
      INR: 70900,
      CHF: 999,
      MXN: 18999,
      JPY: 1089,
      BRL: 3799,
      CNY: 6800
    },
    buyRate: 900
  }]
}, {
  id: 9,
  tag: tag.DOMAINS,
  type: type.PL_DATA,
  plDataCategoryId: plData.MOBI_REGISTRATION_SALE_PROMO,
  key: 'mobi-registration-sale',
  startDate: defaultStartDate,
  endDate: '2019-02-28',
  availability: availability.NOT_INDIA,
  pricing: [{
    product: 'mobi',
    salePrice: {
      USD: 699,
      GBP: 449,
      EUR: 539,
      CAD: 699,
      AUD: 699,
      INR: 37949,
      CHF: 669,
      MXN: 9789,
      JPY: 579,
      BRL: 1539,
      CNY: 4619
    },
    buyRate: 500
  }]
}, {
  id: 10,
  tag: tag.DOMAINS,
  type: type.PL_DATA,
  plDataCategoryId: plData.ME_REGISTRATION_SALE_PROMO,
  key: 'me-registration-sale',
  startDate: defaultStartDate,
  endDate: '2019-02-28',
  availability: availability.NOT_INDIA,
  pricing: [{
    product: 'me',
    salePrice: {
      USD: 799,
      GBP: 519,
      EUR: 619,
      CAD: 799,
      AUD: 799,
      INR: 42949,
      CHF: 759,
      MXN: 11189,
      JPY: 659,
      BRL: 1759,
      CNY: 5279
    },
    buyRate: 725
  }]
}, {
  id: 11,
  tag: tag.DOMAINS,
  type: type.PL_DATA,
  plDataCategoryId: plData.ORG_REGISTRATION_SALE_PROMO,
  key: 'org-registration-sale',
  startDate: defaultStartDate,
  endDate: '2019-02-28',
  availability: availability.NOT_INDIA,
  pricing: [{
    product: 'org',
    salePrice: {
      USD: 999,
      GBP: 799,
      EUR: 899,
      CAD: 1399,
      AUD: 1399,
      INR: 70900,
      CHF: 999,
      MXN: 18999,
      JPY: 1089,
      BRL: 3799,
      CNY: 6800
    },
    buyRate: 849
  }]
}, {
  id: 12,
  tag: tag.DOMAINS,
  type: type.PL_DATA,
  plDataCategoryId: plData.INFO_REGISTRATION_SALE_PROMO,
  key: 'info-registration-sale',
  startDate: defaultStartDate,
  endDate: '2019-02-28',
  availability: availability.NOT_INDIA,
  pricing: [{
    product: 'info',
    salePrice: {
      USD: 499,
      GBP: 399,
      EUR: 399,
      CAD: 599,
      AUD: 599,
      INR: 31900,
      CHF: 499,
      MXN: 6799,
      JPY: 539,
      BRL: 1299,
      CNY: 3199
    },
    buyRate: 439
  }]
}, {
  id: 13,
  tag: tag.DOMAINS,
  type: type.PL_DATA,
  plDataCategoryId: plData.FREE_PRIVATE_REGISTRATION_PROMO,
  key: 'free-private-registration',
  startDate: defaultStartDate,
  endDate: '2020-06-16'
}, {
  id: 14,
  tag: tag.DOMAINS,
  type: type.PL_DATA,
  plDataCategoryId: plData.DOMAINS_BY_PROXY_SALE_PROMO,
  key: 'domains-by-proxy-sale',
  startDate: defaultStartDate,
  endDate: '2020-06-16',
  pricing: [(_ref = {
    product: 'Domains By Proxy'
  }, _defineProperty(_ref, resellerType.PRO, {
    buyRate: 100
  }), _defineProperty(_ref, resellerType.BASIC, {
    buyRate: 150
  }), _ref)]
}, {
  id: 15,
  tag: tag.DOMAINS,
  type: type.PL_DATA,
  plDataCategoryId: plData.INDIA_DOMAIN_SALE_PROMO,
  key: 'india-domain-sale',
  startDate: '2013-05-01',
  endDate: '2023-01-01',
  availability: availability.INDIA_ONLY,
  requiresMultiCurrencyPricing: true,
  ratesAppSettingKeys: {
    'tld-registration': 'RCC_INDIA_TLD_RATES',
    'tld-transfer': 'RCC_INDIA_TLD_TRANSFER_RATES'
  }
}, {
  id: 16,
  type: type.PROMO_OFFERING,
  sectionId: 22,
  groupId: (_groupId = {}, _defineProperty(_groupId, resellerType.PRO, 103), _defineProperty(_groupId, resellerType.BASIC, 104), _groupId),
  isActive: false
}, {
  id: 17,
  type: type.PROMO_OFFERING,
  sectionId: 22,
  groupId: (_groupId2 = {}, _defineProperty(_groupId2, resellerType.PRO, 105), _defineProperty(_groupId2, resellerType.BASIC, 106), _groupId2),
  isActive: false
}, {
  id: 18,
  tag: tag.ORDER_LEVEL,
  type: type.PROMO_OFFERING,
  sectionId: 22,
  groupId: (_groupId3 = {}, _defineProperty(_groupId3, resellerType.PRO, 107), _defineProperty(_groupId3, resellerType.BASIC, 108), _groupId3),
  key: 'order-confirmation',
  startDate: defaultStartDate,
  excludes: [16, 17]
}, {
  id: 19,
  type: type.ORDER_LEVEL,
  iscCode: 'acosplks5',
  isActive: false
}, {
  id: 20,
  type: type.ORDER_LEVEL,
  iscCode: 'acosplks7',
  isActive: false
}, {
  id: 21,
  tag: tag.ORDER_LEVEL,
  type: type.ORDER_LEVEL,
  iscCode: 'acosplks10',
  key: 'keep-shopping',
  startDate: defaultStartDate,
  excludes: [19, 20]
}, {
  id: 22,
  tag: tag.DOMAINS,
  type: type.PROMO_OFFERING,
  sectionId: 3,
  groupId: (_groupId4 = {}, _defineProperty(_groupId4, resellerType.PRO, 33), _defineProperty(_groupId4, resellerType.BASIC, 34), _groupId4),
  buyRatesGroupId: 17,
  key: 'domain-renewal-discounts',
  startDate: defaultStartDate,
  isActive: false
}, {
  id: 23,
  tag: tag.STANDARD,
  type: type.PL_DATA,
  plDataCategoryId: plData.BLACK_FRIDAY_DEALS,
  key: 'black-friday-deals',
  startDate: '2016-11-14',
  endDate: '2016-11-28',
  availability: availability.NOT_INDIA
}, {
  id: 24,
  tag: tag.DOMAINS,
  type: type.PL_DATA,
  plDataCategoryId: plData.RADIX_DOMAINS_REGISTRATION_SALE,
  key: 'radix-registration-sale',
  startDate: '2017-10-01',
  endDate: '2019-02-28',
  pricing: [{
    product: 'online',
    salePrice: {
      USD: 499,
      GBP: 399,
      EUR: 499,
      CAD: 699,
      AUD: 699,
      INR: 31900,
      CHF: 499,
      MXN: 8899,
      JPY: 549,
      BRL: 1599,
      CNY: 3300
    },
    buyRate: 375
  }, {
    product: 'store',
    salePrice: {
      USD: 1199,
      GBP: 999,
      EUR: 1099,
      CAD: 1499,
      AUD: 1599,
      INR: 76900,
      CHF: 1199,
      MXN: 21299,
      JPY: 1309,
      BRL: 3799,
      CNY: 7900
    },
    buyRate: 900
  }, {
    product: 'site',
    salePrice: {
      USD: 299,
      GBP: 299,
      EUR: 299,
      CAD: 399,
      AUD: 399,
      INR: 19900,
      CHF: 299,
      MXN: 5399,
      JPY: 329,
      BRL: 999,
      CNY: 2000
    },
    buyRate: 225
  }, {
    product: 'tech',
    salePrice: {
      USD: 1199,
      GBP: 999,
      EUR: 1099,
      CAD: 1499,
      AUD: 1599,
      INR: 76900,
      CHF: 1199,
      MXN: 21299,
      JPY: 1309,
      BRL: 3799,
      CNY: 7900
    },
    buyRate: 900
  }]
}, {
  id: 25,
  tag: tag.DOMAINS,
  type: type.PL_DATA,
  plDataCategoryId: plData.XYZ_REGISTRATION_SALE,
  key: 'xyz-registration-sale',
  startDate: '2018-03-01',
  endDate: '2018-05-31',
  pricing: [{
    product: 'xyz',
    salePrice: {
      USD: 199,
      GBP: 199,
      EUR: 199,
      CAD: 299,
      AUD: 299,
      INR: 12900,
      CHF: 199,
      MXN: 3699,
      JPY: 219,
      BRL: 699,
      CNY: 1300
    },
    buyRate: 150
  }]
}, {
  id: 26,
  tag: tag.STANDARD,
  type: type.PROMO_OFFERING,
  sectionId: 1,
  groupId: (_groupId5 = {}, _defineProperty(_groupId5, resellerType.PRO, 13), _defineProperty(_groupId5, resellerType.BASIC, 14), _groupId5),
  buyRatesGroupId: 7,
  key: '10-percent-off-12-months-fax-thru-email',
  startDate: defaultStartDate,
  endDate: '2019-04-22'
}, {
  id: 27,
  tag: tag.STANDARD,
  type: type.PROMO_OFFERING,
  sectionId: 1,
  groupId: (_groupId6 = {}, _defineProperty(_groupId6, resellerType.PRO, 15), _defineProperty(_groupId6, resellerType.BASIC, 16), _groupId6),
  buyRatesGroupId: 8,
  key: '15-percent-off-24-or-36-months-fax-thru-email',
  startDate: defaultStartDate,
  endDate: '2019-04-22'
}, {
  id: 28,
  tag: tag.STANDARD,
  type: type.PROMO_OFFERING,
  sectionId: 1,
  groupId: (_groupId7 = {}, _defineProperty(_groupId7, resellerType.PRO, 25), _defineProperty(_groupId7, resellerType.BASIC, 26), _groupId7),
  buyRatesGroupId: 13,
  key: '10-percent-off-12-months-vps-and-dedicated-server',
  startDate: defaultStartDate,
  endDate: '2019-03-17'
}, {
  id: 29,
  tag: tag.STANDARD,
  type: type.PROMO_OFFERING,
  sectionId: 1,
  groupId: (_groupId8 = {}, _defineProperty(_groupId8, resellerType.PRO, 27), _defineProperty(_groupId8, resellerType.BASIC, 28), _groupId8),
  buyRatesGroupId: 14,
  key: '15-percent-off-24-months-vps-and-dedicated-server',
  startDate: defaultStartDate,
  endDate: '2019-03-17'
}, {
  id: 30,
  tag: tag.STANDARD,
  type: type.PL_DATA,
  plDataCategoryId: plData.NEW_WEBSITE_BUILDER_PROMO,
  key: 'new-website-builder-sale',
  startDate: '2018-11-01',
  endDate: '2019-05-01',
  pricing: [(_ref2 = {
    product: 'website-builder-personal'
  }, _defineProperty(_ref2, resellerType.PRO, {
    buyRate: 99,
    salePrice: {
      USD: 200
    }
  }), _defineProperty(_ref2, resellerType.BASIC, {
    buyRate: 200,
    salePrice: {
      USD: 300
    }
  }), _ref2), (_ref3 = {
    product: 'website-builder-business'
  }, _defineProperty(_ref3, resellerType.PRO, {
    buyRate: 200,
    salePrice: {
      USD: 300
    }
  }), _defineProperty(_ref3, resellerType.BASIC, {
    buyRate: 300,
    salePrice: {
      USD: 400
    }
  }), _ref3), (_ref4 = {
    product: 'website-builder-business-plus'
  }, _defineProperty(_ref4, resellerType.PRO, {
    buyRate: 499,
    salePrice: {
      USD: 599
    }
  }), _defineProperty(_ref4, resellerType.BASIC, {
    buyRate: 550,
    salePrice: {
      USD: 700
    }
  }), _ref4)]
}, {
  id: 31,
  tag: tag.DOMAINS,
  type: type.PL_DATA,
  plDataCategoryId: plData.YEAR_LONG_DOMAIN_PROMOTION,
  key: 'year-long-domain-promotion',
  startDate: '2019-03-01',
  endDate: '2019-12-31',
  availability: availability.NOT_INDIA,
  pricing: [{
    product: 'blog',
    salePrice: {
      USD: 999,
      GBP: 799,
      EUR: 899,
      CAD: 1399,
      AUD: 1399,
      INR: 70900,
      CHF: 999,
      MXN: 19199,
      JPY: 1109,
      BRL: 3799,
      CNY: 6700
    },
    buyRate: 699
  }, {
    product: 'biz',
    salePrice: {
      USD: 999,
      GBP: 799,
      EUR: 899,
      CAD: 1399,
      AUD: 1399,
      INR: 70900,
      CHF: 999,
      MXN: 19299,
      JPY: 1109,
      BRL: 3799,
      CNY: 6800
    },
    buyRate: 749
  }, {
    product: 'club',
    salePrice: {
      USD: 999,
      GBP: 799,
      EUR: 899,
      CAD: 1399,
      AUD: 1399,
      INR: 70900,
      CHF: 999,
      MXN: 19299,
      JPY: 1109,
      BRL: 3799,
      CNY: 6800
    },
    buyRate: 699
  }, {
    product: 'co',
    salePrice: {
      USD: 1199,
      GBP: 999,
      EUR: 1099,
      CAD: 1599,
      AUD: 1699,
      INR: 85900,
      CHF: 1199,
      MXN: 23099,
      JPY: 1339,
      BRL: 4499,
      CNY: 8100
    },
    buyRate: 999
  }, {
    product: 'fun',
    salePrice: {
      USD: 499,
      GBP: 399,
      EUR: 499,
      CAD: 699,
      AUD: 699,
      INR: 35900,
      CHF: 499,
      MXN: 9599,
      JPY: 559,
      BRL: 1899,
      CNY: 3400
    },
    buyRate: 349
  }, {
    product: 'host',
    salePrice: {
      USD: 999,
      GBP: 799,
      EUR: 899,
      CAD: 1399,
      AUD: 1399,
      INR: 70900,
      CHF: 999,
      MXN: 19199,
      JPY: 1109,
      BRL: 3799,
      CNY: 6700
    },
    buyRate: 699
  }, {
    product: 'info',
    salePrice: {
      USD: 299,
      GBP: 299,
      EUR: 299,
      CAD: 399,
      AUD: 499,
      INR: 21900,
      CHF: 299,
      MXN: 5799,
      JPY: 339,
      BRL: 1199,
      CNY: 2000
    },
    buyRate: 199
  }, {
    product: 'io',
    salePrice: {
      USD: 4999,
      GBP: 3899,
      EUR: 4399,
      CAD: 6599,
      AUD: 6999,
      INR: 354900,
      CHF: 4999,
      MXN: 95999,
      JPY: 5549,
      BRL: 18599,
      CNY: 33600
    },
    buyRate: 3499
  }, {
    product: 'me',
    salePrice: {
      USD: 999,
      GBP: 799,
      EUR: 899,
      CAD: 1399,
      AUD: 1399,
      INR: 70900,
      CHF: 999,
      MXN: 19299,
      JPY: 1109,
      BRL: 3799,
      CNY: 6800
    },
    buyRate: 849
  }, {
    product: 'mobi',
    salePrice: {
      USD: 499,
      GBP: 399,
      EUR: 499,
      CAD: 699,
      AUD: 699,
      INR: 35900,
      CHF: 499,
      MXN: 9599,
      JPY: 559,
      BRL: 1899,
      CNY: 3400
    },
    buyRate: 249
  }, {
    product: 'online',
    salePrice: {
      USD: 499,
      GBP: 399,
      EUR: 499,
      CAD: 699,
      AUD: 699,
      INR: 35900,
      CHF: 499,
      MXN: 9599,
      JPY: 559,
      BRL: 1899,
      CNY: 3400
    },
    buyRate: 349
  }, {
    product: 'org',
    salePrice: {
      USD: 1199,
      GBP: 999,
      EUR: 1099,
      CAD: 1599,
      AUD: 1699,
      INR: 85900,
      CHF: 1199,
      MXN: 23099,
      JPY: 1339,
      BRL: 4499,
      CNY: 8100
    },
    buyRate: 1099
  }, {
    product: 'pro',
    salePrice: {
      USD: 499,
      GBP: 399,
      EUR: 499,
      CAD: 699,
      AUD: 699,
      INR: 35900,
      CHF: 499,
      MXN: 9599,
      JPY: 559,
      BRL: 1899,
      CNY: 3400
    },
    buyRate: 349
  }, {
    product: 'shop',
    salePrice: {
      USD: 999,
      GBP: 799,
      EUR: 899,
      CAD: 1399,
      AUD: 1399,
      INR: 70900,
      CHF: 999,
      MXN: 19299,
      JPY: 1109,
      BRL: 3799,
      CNY: 6800
    },
    buyRate: 749
  }, {
    product: 'site',
    salePrice: {
      USD: 299,
      GBP: 299,
      EUR: 299,
      CAD: 399,
      AUD: 499,
      INR: 21900,
      CHF: 299,
      MXN: 5799,
      JPY: 339,
      BRL: 1199,
      CNY: 2000
    },
    buyRate: 199
  }, {
    product: 'space',
    salePrice: {
      USD: 249,
      GBP: 199,
      EUR: 299,
      CAD: 399,
      AUD: 399,
      INR: 17900,
      CHF: 299,
      MXN: 4799,
      JPY: 279,
      BRL: 999,
      CNY: 1700
    },
    buyRate: 199
  }, {
    product: 'store',
    salePrice: {
      USD: 999,
      GBP: 799,
      EUR: 899,
      CAD: 1399,
      AUD: 1399,
      INR: 70900,
      CHF: 999,
      MXN: 19299,
      JPY: 1109,
      BRL: 3799,
      CNY: 6800
    },
    buyRate: 749
  }, {
    product: 'tech',
    salePrice: {
      USD: 999,
      GBP: 799,
      EUR: 899,
      CAD: 1399,
      AUD: 1399,
      INR: 70900,
      CHF: 999,
      MXN: 19299,
      JPY: 1109,
      BRL: 3799,
      CNY: 6800
    },
    buyRate: 749
  }, {
    product: 'us',
    salePrice: {
      USD: 799,
      GBP: 699,
      EUR: 799,
      CAD: 1099,
      AUD: 1199,
      INR: 56900,
      CHF: 799,
      MXN: 15399,
      JPY: 889,
      BRL: 2999,
      CNY: 5400
    },
    buyRate: 549
  }, {
    product: 'vip',
    salePrice: {
      USD: 799,
      GBP: 699,
      EUR: 799,
      CAD: 1099,
      AUD: 1199,
      INR: 56900,
      CHF: 799,
      MXN: 15399,
      JPY: 889,
      BRL: 2999,
      CNY: 5400
    },
    buyRate: 549
  }, {
    product: 'website',
    salePrice: {
      USD: 299,
      GBP: 299,
      EUR: 299,
      CAD: 399,
      AUD: 499,
      INR: 21900,
      CHF: 299,
      MXN: 5799,
      JPY: 339,
      BRL: 1199,
      CNY: 2000
    },
    buyRate: 199
  }, {
    product: 'work',
    salePrice: {
      USD: 299,
      GBP: 299,
      EUR: 299,
      CAD: 399,
      AUD: 499,
      INR: 21900,
      CHF: 299,
      MXN: 5799,
      JPY: 339,
      BRL: 1199,
      CNY: 2000
    },
    buyRate: 199
  }, {
    product: 'ws',
    salePrice: {
      USD: 499,
      GBP: 399,
      EUR: 499,
      CAD: 699,
      AUD: 699,
      INR: 35900,
      CHF: 499,
      MXN: 9599,
      JPY: 559,
      BRL: 1899,
      CNY: 3400
    },
    buyRate: 349
  }, {
    product: 'xyz',
    salePrice: {
      USD: 99,
      GBP: 99,
      EUR: 99,
      CAD: 199,
      AUD: 199,
      INR: 7900,
      CHF: 99,
      MXN: 1999,
      JPY: 109,
      BRL: 399,
      CNY: 700
    },
    buyRate: 49
  }]
}, {
  id: 32,
  tag: tag.STANDARD,
  type: type.PL_DATA,
  plDataCategoryId: plData.YEARLY_TERMS_HOSTING_PROMO,
  key: 'hosting-promotions-for-yearly-terms',
  startDate: '2019-03-18',
  endDate: '2019-06-18',
  availability: availability.NOT_INDIA,
  customerAvailability: function customerAvailability(_ref5) {
    var currency = _ref5.currency;
    return !!currency && ['USD', 'CAD', 'MXN', 'GBP'].includes(currency.toUpperCase());
  }
}, {
  id: 33,
  tag: tag.ORDER_LEVEL,
  type: type.PL_DATA,
  plDataCategoryId: plData.SECURITY_BUNDLE_PROMO,
  iscCode: '30offsec',
  key: '30-percent-off-security-bundle',
  optInDeadline: '2019-07-19',
  startDate: '2019-07-22',
  endDate: '2019-10-31'
}, {
  id: 34,
  tag: tag.STANDARD,
  type: type.PL_DATA,
  plDataCategoryId: plData.INDIA_OX_PROMO,
  key: 'india-ox-promotion',
  startDate: '2019-11-20',
  endDate: '2024-01-01',
  availability: availability.INDIA_ONLY,
  pricing: [(_ref6 = {
    product: 'professional-email-individual'
  }, _defineProperty(_ref6, resellerType.PRO, {
    buyRate: 540,
    salePrice: {
      INR: 58800
    }
  }), _defineProperty(_ref6, resellerType.BASIC, {
    buyRate: 588,
    salePrice: {
      INR: 58800
    }
  }), _ref6), (_ref7 = {
    product: 'professional-email-team'
  }, _defineProperty(_ref7, resellerType.PRO, {
    buyRate: 780,
    salePrice: {
      INR: 82800
    }
  }), _defineProperty(_ref7, resellerType.BASIC, {
    buyRate: 828,
    salePrice: {
      INR: 82800
    }
  }), _ref7)]
}, {
  id: 35,
  tag: tag.ORDER_LEVEL,
  type: type.PL_DATA_DATE,
  plDataCategoryId: plData.COVID_19_RELIEF_PROMO_20_PERCENT,
  key: 'covid-19-relief-20-percent',
  optInDeadline: '2020-07-13',
  startDate: '2020-07-21',
  endDate: '2020-08-20'
}, {
  id: 36,
  tag: tag.ORDER_LEVEL,
  type: type.PL_DATA_DATE,
  plDataCategoryId: plData.COVID_19_RELIEF_PROMO_35_PERCENT,
  key: 'covid-19-relief-35-percent',
  optInDeadline: '2020-07-13',
  startDate: '2020-07-21',
  endDate: '2020-08-20'
}];